__turbopack_context__.v({
  "button": "AuthModal-module__I8_JwW__button",
});
